import gsap from "gsap";

export default {
  init() {
    // Header Animation
    const $homeBannerSlider = $(".home-banner-slider");

    if ($homeBannerSlider) {
      gsap.set($homeBannerSlider, { opacity: 0 });

      gsap.to($homeBannerSlider, {
        opacity: 1,
        duration: 1.0,
        ease: "easeOutCirc",
        delay: 0.5
      });
    }

    const $sliderInnerContent = $(".slider-content .slider-content-inner").children();

    if ($sliderInnerContent) {
      gsap.fromTo($sliderInnerContent,{
        opacity: 0,
        y: "100%"
      }, {
        opacity: 1,
        y: "0%",
        stagger: 0.25,
        duration: 0.5,
      });
    }

    // news-sec-bg Animation
    const $newsSecBg = $(".news-sec-bg");

    $newsSecBg.each((index, element) => {
        const $displays = $(element).find("[class^=display-]");

        gsap.fromTo($displays, {
          opacity: 0,
          y: "25%"
        }, {
          scrollTrigger: element,
          opacity: 1,
          y: "0%",
          stagger: 0.1,
          duration: 0.5,
        });
    });

    // squad-main Animation
    const $squadMain = $(".squad-main");

    $squadMain.each((index, element) => {
      const $displayParent = $(element).find(".display-parent");

      $displayParent.each((index, displayParent) => {
        const $displays = $(displayParent).find("[class^=display-]");

        gsap.fromTo($displays, {
          opacity: 0,
          y: "25%"
        }, {
          scrollTrigger: displayParent,
          opacity: 1,
          y: "0%",
          stagger: 0.1,
          duration: 0.5,
        });
      });
    });
  },
  finalize() { },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js